import styled from 'vue3-styled-components';
import { injectGlobal } from 'vue3-styled-components';

injectGlobal`
    .bcode_load_tr{
        border: 1px solid #ddd;
        border-radius: 5px;
        &:hover{
            background: #f0f0f0;
        }
        cursor: pointer;
        td{
            padding:5px 20px;
        }
    }
    @keyframes buzz {
        10% { transform: translateX(3px) rotate(2deg); }
        20% { transform: translateX(-3px) rotate(-2deg); }
        30% { transform: translateX(3px) rotate(2deg); }
        40% { transform: translateX(-3px) rotate(-2deg); }
        50% { transform: translateX(2px) rotate(1deg); }
        60% { transform: translateX(-2px) rotate(-1deg); }
        70% { transform: translateX(2px) rotate(1deg); }
        80% { transform: translateX(-2px) rotate(-1deg); }
        90% { transform: translateX(1px) rotate(0); }
        100% { transform: translateX(-1px) rotate(0); }
    }
`;

export const OrderUpDiv = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    min-height: calc(100vh - 90px);
    overflow-y: auto;
`;

export const OrderUpTitleArea = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
`;

export const OrderUpTitleDiv = styled.h1`
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 16px;
  font-weight: 600;
  display: inline-block;
  position: relative;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  background-color: #f8f1e9;
  color: #cc5803;
  border: 2px solid #cc5803;
  
  &::before {
    content: '●';
    margin-right: 8px;
    font-size: 12px;
    vertical-align: middle;
  }
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }
`;

export const OrderUpClientArea = styled.div`
    flex: 0.38;
    display: flex;
    flex-direction: column;
    padding: 10px;
    background: #fff5e6;
    border: 2px solid #fb8b24;
    border-radius: 10px;
    height: calc(100vh - 110px);
    overflow-y: auto;           
    overflow-x: hidden;         
    position: sticky;        
`;

export const OrderUpCenterArea = styled.div`
    width: 2%;
`;

export const OrderUpProductArea = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    padding-left: 15px;
`;

export const OrderUpClientBtnContainer = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
`;

export const OrderUpClientUpBtn = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    margin-bottom: 10px;
    margin-right: 10px;
    border-radius: 5px;
    padding: 8px;
    cursor: pointer;
    width: fit-content;
    background: #0f4c5c;
    color: #fff;
    font-size: 14px;

    &:hover {
        cursor: pointer;
        transform: translateY(-3px);
      }

    &:active {
        transform: translateY(-1px);
    }
}`;

// 제조사 주문품목 영역
export const ManufacturerOrderArea = styled.div`
    display: flex;
    flex-direction: column;
    padding: 10px;
    background: #fff5e6;
    border: 2px solid #fb8b24;
    border-radius: 10px;
    margin-top: 30px;
`;

export const StoreOrderArea = styled.div`
    display: flex;
    flex-direction: column;
    padding: 10px;
    background: #fff5e6;
    border: 2px solid #fb8b24;
    border-radius: 10px;
`;

export const SectionTitle = styled.h3`
  font-size: 22px;
  font-weight: bold;
  margin: 20px 0 10px;
  padding-left: 10px;
  text-align: center;
  margin-bottom: 30px;
  color: #cc5803;
`;

export const SectionTitle2 = styled.h3`
  font-size: 22px;
  font-weight: bold;
  margin: 20px 0 10px;
  padding-left: 10px;
  text-align: center;
  margin-top: 15px;
  margin-bottom: 30px;
  color: #cc5803;
`;

export const OrderTypeTag = styled.span`
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 16px;
  font-weight: 600;
  display: inline-block;
  position: relative;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  
  &.normal {
    background-color: #f8f1e9;
    color: #cc5803;
    border: 2px solid #cc5803;
  }
  
  &::before {
    content: '●';
    margin-right: 8px;
    font-size: 12px;
    vertical-align: middle;
  }
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }
`;

export const OrderUpClientTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
}`;

export const OrderUpClientTr = styled.tr`
    border: 1px solid #ddd;
}`;

export const OrderUpClientInputTxtW150 = styled.input`
    width: 117px;
    height: 30px;
    
    &.blurred {
        filter: blur(4px) !important;
        pointer-events: auto;
        user-select: auto;
        -webkit-user-select: auto;
        -moz-user-select: auto;
        -ms-user-select: auto;
    }
`;

export const OrderUpClientInputTxtW260 = styled.input`
    width: 220px;
    height: 30px;
    
    &.blurred {
        filter: blur(4px) !important;
        pointer-events: auto;
        user-select: auto;
        -webkit-user-select: auto;
        -moz-user-select: auto;
        -ms-user-select: auto;
    }
`;

export const OrderUpClientInputTxtW80per = styled.input`
    width:80%;
    height: 30px;
`;

export const OrderModifyClientMemoArea = styled.td`

`;

export const OrderModifyClientMemoBtn = styled.span`
    box-shadow: 0 8px 9px -4px rgba(0, 0, 0, 0.3), 0 4px 18px 0 rgba(0, 0, 0, 0.2);
    text-align: center;
    cursor: pointer;
    border-radius: 3px;
    padding: 7px 10px;
    font-weight: bold;
    font-size: 15px;
    background: #fff;
    margin-left: 10px;

    &:hover {
        cursor: pointer;
        transform: translateY(-3px);
        box-shadow: 0 12px 15px -4px rgba(0,0,0,0.4), 0 6px 24px 0 rgba(0,0,0,0.3);
      }

    &:active {
        transform: translateY(-1px);
        box-shadow: 0 10px 12px -4px rgba(0,0,0,0.35), 0 5px 21px 0 rgba(0,0,0,0.25);
    }
`;

export const OrderUpClientSelectW150 = styled.select`
    width:150px;
    height: 40px;
`;

export const OrderUpClientSelectW162 = styled.select`
    width: 130px;
    height: 40px;
    
    &.blurred {
        filter: blur(4px) !important;
        pointer-events: auto;
        user-select: auto;
        -webkit-user-select: auto;
        -moz-user-select: auto;
        -ms-user-select: auto;
    }
`;

export const OrderUpClientTableTd = styled.td`
    text-align: center;
    width: 100px;
    font-size: 14px;
    background: #fb8b24;
    color: #000;
`;

export const OrderUpClientTableTr = styled.tr`
    margin: 10px;
`;

export const orderUpClientAddressBtn = styled.button`
    background: #ffc971;
    height: 30px;
    margin: 5px;
    border: 1px solid #fb8b24;
    border-radius: 3px;
    box-shadow: 1px 1px 1px 1px #fb8b24;
    font-size: 15px;
    cursor: pointer;
    width: 120px;
`;

export const OrderCommentTextarea = styled.textarea`
    width: 100%;
    height: 100px;
    
    &.blurred {
        filter: blur(4px) !important;
        pointer-events: auto;
        user-select: auto;
        -webkit-user-select: auto;
        -moz-user-select: auto;
        -ms-user-select: auto;
    }
`;

export const CommentContainer = styled.div`
    position: relative;
`;

export const CommentThumbnailArea = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 5px;
    position: relative;
`;

export const CommentThumbnail = styled.div`
    margin: 5px;
    position: relative;
    img{
        width:100px;
        object-fit: cover;
    }
    button{
        position: absolute;
        top: 0;
        left: 0;
        background: rgba(255, 255, 255, 0.7);
        border: none;
        cursor: pointer;
    }
`;

export const CommentImageUploadArea = styled.div`
    button{
        display: flex;
        align-items: center;
        box-shadow: 0 8px 9px -4px rgba(175, 156, 156, 0.3), 0 4px 18px 0 rgba(0, 0, 0, 0.2);
        background: #fff;
        font-weight: bold;
        border: none;
        border-radius: 5px;
        cursor: pointer;
        padding: 10px 20px;
        margin: 5px;
        &:hover{
            background: #f0f0f0;
        }
    }
`;

export const CommentTitleDiv = styled.div`
    font-weight: bold;
    font-size: 17px;
    padding: 10px;
    display: flex;
    align-items: center;
`;

export const CommentTextDiv = styled.div`
    font-size: 17px;
    line-height: 30px;
    padding: 0px 10px;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ccc;

    &.no-border {
        border-bottom: none;
    }
`;

// ! 품목 테이블 Area
export const OrderUpProductHeaderArea = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    width: 100%;
}`;

export const OrderUpProductTableContainer = styled.div`
    border: 1px solid #fb8b24;
    border-radius: 10px 10px 0 0;
    overflow: hidden;
    margin-top: 10px;
`;

export const OrderUpProductHeaderBtn = styled.div`
    cursor: pointer;
    border: 1px solid #0f4c5c;
    border-radius: 5px;
    padding: 6px;
    background: #0f4c5c;
    color: #fff;
    font-size: 15px;
    
    &:hover {
        cursor: pointer;
        transform: translateY(-3px);
      }

    &:active {
        transform: translateY(-1px);
    }
}`;

export const OrderUpProductHeaderImageBtn = styled.div`
    cursor: pointer;
    border: 1px solid #0f4c5c;
    border-radius: 5px;
    padding: 6px;
    background: #0f4c5c;
    color: #fff;
    margin-left: 10px;
    font-size: 15px;

    &:hover {
        cursor: pointer;
        transform: translateY(-3px);
      }

    &:active {
        transform: translateY(-1px);
    }
}`;

export const OrderUpProductTable = styled.table`
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    table-layout: fixed;
    font-size: 13px;
    
    thead tr:first-child {
        th:first-child {
            border-top-left-radius: 10px;
        }
        th:last-child {
            border-top-right-radius: 10px;
        }
    }

    th {
        background: #fb8b24;
        border-top: 1px solid #fb8b24;
    }

    th, td {
        padding: 4px;
        text-align: center;
        vertical-align: middle;
        border-bottom: 1px solid #fb8b24;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    td {
        background: #fff;
    }

    th:nth-child(1) { width: 5%; }  // 선택
    th:nth-child(2) { width: 10%; }  // 거래처
    th:nth-child(3) { width: 15%; } // 바코드
    th:nth-child(4) { width: 10%; }  // 품목분류
    th:nth-child(5) { width: 15%; } // 품목명
    th:nth-child(6) { width: 5%; }  // 사이즈
    th:nth-child(7) { width: 5%; }  // 색상
    th:nth-child(8) { width: 10%; } // 비고
    th:nth-child(9) { width: 5%; }  // 수량
    th:nth-child(10) { width: 6%; } // 단가
    th:nth-child(11) { width: 6%; } // 차액
    th:nth-child(12) { width: 6%; } // 품목 합계
    th:nth-child(13) { width: 3%; } // 삭제
    th:nth-child(14) { width: 5%; } // 상세

    input, select {
        width: 90%;
        padding: 2px;
        font-size: 12px;
    }
`;

export const OrderUpProductTableTheadTr = styled.tr`
    background-color: #fb8b24;
    color: #000;
    height: 40px;

    th {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
`;

export const OrderUpProductUpArea = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}`;

export const OrderUpPorudctUpBtn = styled.div`
    margin: 15px;
    margin-bottom: 0px;
    cursor: pointer;
    border: 0 solid;
    border-radius: 5px;
    color: #fff;
    background: rgb(204, 65, 77);
    padding: 6px;
    font-size: 14px;
    font-weight: bold;
    display: flex;
    align-items: center;
    
    &:hover{
        animation: buzz 0.8s ease-in-out;
    }
}`;

export const OrderUpSubmitArea = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-top: 30px;
`;

const ButtonBase = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 16px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border: none;
  cursor: pointer;
  margin: 0 10px;
  min-width: 150px;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);
  }
  
  &:active {
    transform: translateY(1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  
  @media (max-width: 768px) {
    padding: 10px 16px;
    font-size: 14px;
    min-width: 120px;
  }
`;

// 주문하기 버튼 - 밝은 파란색 계열
export const OrderButton = styled(ButtonBase)`
  background: linear-gradient(135deg, #3182ce, #4299e1);
  color: white;
  
  &:hover {
    background: linear-gradient(135deg, #2c5282, #3182ce);
  }
`;

// 산소발생기 청구 버튼 - 밝은 보라색 계열
export const OxygenButton = styled(ButtonBase)`
  background: linear-gradient(135deg, #6b46c1, #805ad5);
  color: white;
  
  &:hover {
    background: linear-gradient(135deg, #553c9a, #6b46c1);
  }
`;

// 보장구 청구 버튼 - 밝은 청록색 계열
export const MedicalDeviceButton = styled(ButtonBase)`
  background: linear-gradient(135deg, #38a169, #48bb78);
  color: white;
  
  &:hover {
    background: linear-gradient(135deg, #2f855a, #38a169);
  }
`;

// 당뇨소모성재료 청구 버튼 - 밝은 주황색 계열
export const DiabetesButton = styled(ButtonBase)`
  background: linear-gradient(135deg, #c05621, #dd6b20);
  color: white;
  
  &:hover {
    background: linear-gradient(135deg, #9c4221, #c05621);
  }
`;

export const ButtonIcon = styled.span`
  margin-right: 8px;
  font-size: 18px;
`;

export const ButtonText = styled.span`
  letter-spacing: 0.5px;
`;

export const OrderUPProductTableTotalPriceTr = styled.tr`
    td {
        border: none;
        border-top: 1px solid #ddd;
        border-bottom: 1px solid #ddd;
        font-weight: bold;
        padding: 10px 8px;
    }
}`;

export const OrderupProductCntInput = styled.input`
    width: 40px !important;
    text-align: center;
    margin: 0 2px;
    padding: 2px;
`;

export const OrderUpProductTableInput = styled.input`
    width: 18px;
    height: 18px;
    cursor: pointer;
`;

export const QuantityFlexDiv = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;  // 요소들 사이 간격
`;

export const QuantityButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 4px;
    justify-content: center;
`;

export const HanqBtn = styled.button`
    font-size: 12px;
    background: #fb8b24;
    width: 22px;
    height: 20px;
    color: #fff;
    border: 1px solid #fb8b24;
    border-radius: 5px;
    cursor: pointer;

    &:hover {
        background: #f0f0f0;
        color: #000;
    }

    &:active {
        transform: translateY(-1px);
    }
`;

export const OrderUpProductTableInputTxt = styled.input`
    width: 100%;
    height: 27px;
    padding: 0 5px;
`;

export const OrderUpProductTableBcodeAreaDiv = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 5px;
`;

export const OrderUpProductTableColorSelect = styled.select`
    width: 100%;
    height: 30px;
    padding: 0 5px;
    border: 1px solid #ccc;
    border-radius: 3px;
`;

export const OrderUpProductTableSizeSelect = styled.select`
    width: 100%;
    height: 30px;
    padding: 0 5px;
    border: 1px solid #ccc;
`;

export const OrderUpBcodeLoadTr = styled.tr`
    &:hover{
        background: #f0f0f0;
    }
    cursor: pointer;
`;

export const QuantityInput = styled.input`
    width: 5px;
    height: 20px;
    border-radius: 5px;
    border: 1px solid #000;
    margin: 0 5px;
    text-align: center;
`;

export const StatusIcon = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    
    &.success {
        color: #2ecc71;  // 초록색
    }
    
    &.error {
        color: #e74c3c;  // 빨간색
    }
`;

// 합계 영역을 위한 새로운 스타일 컴포넌트 추가
export const OrderTotalArea = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    background: #ffc971;
    border-left: 1px solid #fb8b24;
    border-right: 1px solid #fb8b24;
    border-bottom: 1px solid #fb8b24;
    border-radius: 0 0 10px 10px;
    margin-top: -2px;
`;

export const TotalInfoContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 20px;
    padding: 0 20px;
`;

export const TotalInfoItem = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    font-weight: bold;
    font-size: 14px;
    color: #0f4c5c;
`;

// 결제방식 영역 컨테이너
export const PaymentMethodContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 15px;
`;

export const PaymentMethodLabel = styled.label`
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    font-size: 14px;

    input[type="radio"] {
        cursor: pointer;
        margin: 0;
    }
`;

export const SummaryRightContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    gap: 20px;
    margin-left: auto;
`;

export const EditableField = styled.div`
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  position: relative;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: #f0f7ff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }
  
  &:hover::after {
    content: "클릭하여 편집";
    position: absolute;
    bottom: -25px;
    left: 50%;
    transform: translateX(-50%);
    background-color: rgba(0, 0, 0, 0.7);
    color: white;
    padding: 3px 8px;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
    z-index: 10;
  }
  
  &:hover::before {
    content: "✎";
    position: absolute;
    right: -15px;
    color: #4a90e2;
    font-size: 14px;
  }
`;

// ! 품목 이미지 미리보기
export const ProductImagePreview = styled.div`
  position: fixed;
  z-index: 99;
  background: #fff;
  border: 1px solid #ddd;
  padding: 8px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  transition: all 0.2s ease;
`;

export const ProductPreviewImg = styled.img`
  display: block;
  width: 180px;
  height: 180px;
  object-fit: contain;
  border: 2px solid #fb8b24;
  border-radius: 8px;
  padding: 12px;
  background-color: white;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
`;

export const ProductNameCell = styled.td`
  cursor: pointer;
  
  &:hover {
    color: #cc5803;
    font-weight: bold;
  }
`;

// 삭제 버튼 스타일
export const DeleteButton = styled.button`
  background: none;
  border: none;
  padding: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #dc3545;
  transition: all 0.2s;
  border-radius: 4px;
  
  &:hover {
    background-color: rgba(220, 53, 69, 0.1);
    transform: scale(1.1);
  }
  
  &:active {
    transform: scale(0.95);
  }
`;

// 체크박스 스타일
export const OrderUpProductTableCheckbox = styled.input`
  width: 18px;
  height: 18px;
  cursor: pointer;
`;

// * 확장된 행 스타일
export const ExpandButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    
    &:hover {
        color: #cc5803;
    }
`;

export const ProductExpandedRowStyles = `
  .product-expanded-row {
    padding: 8px;
    background-color: #f8f9fa;
    border-radius: 6px;
    margin: 4px 0;
    text-align: center;
  }

  .product-expanded-row .product-card-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 8px;
  }

  .product-expanded-row .product-info-card {
    background-color: white;
    border-radius: 6px;
    padding: 12px 10px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: column;
    height: 70px; /* 카드 높이 증가 */
    align-items: center;
    justify-content: center;
  }

  .product-expanded-row .product-card-title {
    font-size: 12px;
    font-weight: 600;
    color: #495057;
    margin: 0 0 12px 0; /* 마진 증가 */
    padding-bottom: 3px; /* 패딩 증가 */
    border-bottom: 1px solid #e9ecef;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    text-align: center;
    width: 100%;
  }

  .product-expanded-row .product-price-row {
    display: flex;
    justify-content: center;
    gap: 8px;
    width: 100%;
    flex: 1; /* 남은 공간 채우기 */
    align-items: center;
  }

  .product-expanded-row .product-price-item {
    flex: 1;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
  }

  .product-expanded-row .product-info-label {
    font-size: 11px;
    color: #6c757d;
    margin-bottom: 5px; /* 마진 증가 */
    text-align: center;
  }

  .product-expanded-row .product-price-value {
    font-size: 14px;
    font-weight: 600;
    color: #0f4c5c;
    text-align: center;
  }

  .product-expanded-row .product-toggle-switch {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-top: 5px;
  }

  .product-expanded-row .product-toggle-switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .product-expanded-row .product-toggle-switch .slider {
    position: relative;
    display: inline-block;
    width: 35px;
    height: 18px;
    background-color: #e9ecef;
    transition: 0.2s;
    border-radius: 20px;
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
  }

  .product-expanded-row .product-toggle-switch .slider:before {
    position: absolute;
    content: "";
    height: 15px;
    width: 15px;
    left: 2px;
    bottom: 2px;
    background-color: white;
    transition: 0.2s;
    border-radius: 50%;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  }

  .product-expanded-row .product-toggle-switch input:checked + .slider {
    background-color: #0f4c5c;
  }

  .product-expanded-row .product-toggle-switch input:checked + .slider:before {
    transform: translateX(16px);
  }
`;